<nav class="side-nav" [class.expanded]="isExpanded" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="nav-content">
    <ul class="nav-menu">
      @for (item of menuItems; track item.route) {
      <li class="nav-item">
        @if (!item.children) {
        <a [routerLink]="item.route" routerLinkActive="active" class="nav-link" [title]="item.label">
          <i [class]="item.icon" class="nav-icon"></i>
          <span class="nav-label">{{ item.label }}</span>
        </a>
        }
        @if (item.children) {
        <div class="nav-item-with-children">
          <a (click)="toggleSubmenu(item)" class="nav-link" [class.active]="isSubmenuExpanded(item)" [title]="item.label">
            <i [class]="item.icon" class="nav-icon"></i>
            <span class="nav-label">{{ item.label }}</span>
            <i class="fas fa-chevron-right expand-icon" [class.rotated]="isSubmenuExpanded(item)"></i>
          </a>
          <ul class="submenu" [class.show]="isSubmenuExpanded(item)">
            @for (child of item.children; track child.route) {
            <li class="submenu-item">
              <a [routerLink]="child.route" routerLinkActive="active" class="submenu-link" [title]="child.label">
                <i [class]="child.icon" class="submenu-icon"></i>
                <span class="submenu-label">{{ child.label }}</span>
              </a>
            </li>
            }
          </ul>
        </div>
        }
      </li>
      }
    </ul>
  </div>
</nav>
